<template>
  <div class="action-tab" data-cy="action-substitution-tab" >
    <substitutions
      :substitutions="substitutions"
      @updated:substitution="updatedSubstitution"
    ></substitutions>
  </div>
</template>

<script>
import Substitutions from "./substitutions";
import { HasError } from "@springbig/sb-components";

export default {
  name: "notification-substitution",

  directives: {
    HasError
  },

  components: {
    Substitutions
  },

  data() {
    return {
      substitutions: [
        { label: 'member first name', tag: 'MEMBER_FIRST_NAME'}
      ]
    };
  },

  methods: {
    updatedSubstitution(sub) {
      this.$emit('shouldInsertFirstName', `%{${sub.tag}}`);
    }
  },

}
</script>

<style scoped>
.action-tab {
  border: 1px solid #A6D4FC;
  border-top: 0;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  color: white;
  display: flex;
  flex-direction: column;
  font-size: 18px;
  align-items: left;
  min-width: 105px;
}
</style>
